var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProcesses = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "758F5602-6619-4552-AA25-812C96362B08") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "project-copy-2",
    transform: "translate(-28.000000, -223.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8765957,0 L1.0893617,0 C0.487723847,0 0,0.487723847 0,1.0893617 L0,22.8765957 C0,23.4782336 0.487723847,23.9659574 1.0893617,23.9659574 L22.8765957,23.9659574 C23.4782336,23.9659574 23.9659574,23.4782336 23.9659574,22.8765957 L23.9659574,1.0893617 C23.9659574,0.487723847 23.4782336,0 22.8765957,0 Z M2.1787234,2.1787234 L10.893617,2.1787234 L10.893617,10.893617 L2.1787234,10.893617 L2.1787234,2.1787234 Z M2.1787234,21.787234 L2.1787234,13.0723404 L10.893617,13.0723404 L10.893617,21.787234 L2.1787234,21.787234 Z M21.787234,21.787234 L13.0723404,21.787234 L13.0723404,2.1787234 L21.787234,2.1787234 L21.787234,21.787234 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProcesses);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/processes.8d3d536b9c7200e7859bed3f8a7bfb45.svg";